module.exports = __webpack_public_path__ + "static/img/banner.965728d.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/banner.png
// module id = h1/f
// module chunks = 1